import {
  PromptRefinementResponse,
  promptRefinement,
} from '@api/api/prompt-refinement';
import { Mention } from '@design/chat/mention-composer';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

interface RefinePromptParams {
  question: string;
  mentions?: Mention[];
  mentionsEnabled?: boolean;
  signal?: AbortSignal;
}

export const refinePrompt = ({
  question,
  mentions,
  mentionsEnabled = false,
  signal,
}: RefinePromptParams) => {
  const { path, schema } = mentionsEnabled
    ? promptRefinement.refinePromptWithMentions
    : promptRefinement.refinePrompt;

  return wretchRequest<PromptRefinementResponse>(path, {
    method: 'post',
    body: mentionsEnabled ? { question, mentions } : { question },
    schema,
    signal,
  });
};
